import axiosInstance from "./axiosInstant";
import Toast from "./Toast";

// Run in backend: npx web-push generate-vapid-keys
const pushSubscriber = async () => {
    if ('serviceWorker' in navigator) {
        try {
            const registration = await navigator.serviceWorker.ready;
            if (registration.active.state === 'activated') return;
            // PushManager se subscription request
            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: 'BJrtOFLQyRQ8i1PDdBDyH_duYkbaXjHWu3MWPEvi_XS5GK-HdS0yZKyyeXXV-OymGNoi5t0gw9_4gaU082Kz8ys', // Replace with your public VAPID key
            });

            const {data} = await axiosInstance.post("/inbox/push_subscription", {type: 'web', ...subscription});
            Toast(data.status ? 'success' : 'error', data.message);
            //console.log('User is subscribed:', data);
        } catch (error) {
            console.error('Subscription failed:', error);
        }
    } else {
        console.error('Service Worker is not supported in this browser.');
    }
};

export default pushSubscriber;
